import React from 'react';

// Catches a render error (or a lazy page's chunk that failed to load) below
// it and shows the message with a Reload button instead of a blank page.
// The one class component the rules allow: React has no hook for this.
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // The error itself, so the console keeps its stack
    console.error('[ErrorBoundary] render failed:', error, info?.componentStack);
  }

  render() {
    const { error } = this.state;
    if (!error) return this.props.children;
    const message = typeof error?.message === 'string' && error.message ? error.message : 'Something went wrong';
    return (
      <div className="main-content">
        <div className="message message-error rp-error">
          <span>This page failed to load: {message}</span>
          <button type="button" className="btn btn-secondary btn-sm" onClick={() => window.location.reload()}>
            Reload
          </button>
        </div>
      </div>
    );
  }
}

export default ErrorBoundary;
